import { environment } from 'src/environments/environment';

/**
 * URL propia del portal (plan ~/Documents/multicomercio/url-propia/PLAN.md, S4). Lo que comparten el alta,
 * la puesta en marcha y la ficha: las siglas sugeridas, el dominio y la forma del acrónimo.
 */

/** Como en la maqueta aprobada: palabras de sociedad al final y conectores que no cuentan para las siglas. */
const SOCIEDADES = new Set(['SA', 'CA', 'SRL', 'INC', 'LTDA', 'LTD']);
const CONECTORES = new Set(['DE', 'DEL', 'LA', 'LAS', 'EL', 'LOS', 'Y', 'E', 'THE', 'OF', 'AND']);

/** Las siglas que se sugieren del nombre comercial (regla `sigDe` de la maqueta). */
export function siglasDe(nombre: string): string {
  const p = String(nombre || '').normalize('NFD').replace(/[̀-ͯ]/g, '')
    .replace(/\b([A-Za-z])\./g, '$1').replace(/[^A-Za-z ]/g, ' ').split(/\s+/).filter(Boolean);
  while (p.length > 1 && SOCIEDADES.has(p[p.length - 1].toUpperCase())) p.pop();
  const u = p.filter((w) => !CONECTORES.has(w.toUpperCase()));
  const w = u.length ? u : p;
  const s = w.length === 1 ? w[0].slice(0, 4) : w.map((x) => x[0]).join('');
  return s.toUpperCase().slice(0, 5);
}

/** A mayúsculas, sin lo que no sea letra, máximo 5 (como se escribe en el campo). */
export const limpiarSiglas = (v: string): string => String(v || '').toUpperCase().replace(/[^A-Z]/g, '').slice(0, 5);
export const siglasValidas = (v: string): boolean => /^[A-Z]{2,5}$/.test(v || '');

/** Misma gramática del núcleo (`helpers/acronimo.js`): minúsculas, números y guiones, sin guion en las puntas. */
export const acronimoConFormato = (v: string): boolean => /^[a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?$/.test(v || '');

/** El dominio base de la dirección propia de este ambiente (`URL_PROPIA_DOMINIO_BASE` en el environment). */
export const dominioPortal = (): string =>
  String((environment as any).URL_PROPIA_DOMINIO_BASE || 'mc.creditotal.online').replace(/^\.+|\.+$/g, '');

export const hostDelAcronimo = (acronimo: string): string => `${acronimo}.${dominioPortal()}`;
